<script>
import CandidateImage from '@/components/candidate/candidate-image.vue'
import {
  MultitentativeFillStatus,
  MultitentativeFillStatusLabels,
} from '@/shared/constants/booking/MultitentativeFillStatus'
import BaseLabel from '@/components/_base-label.vue'
import BaseLabelColor from '@/shared/constants/baseComponents/baseLabel/BaseLabelColor'
import BaseLabelShade from '@/shared/constants/baseComponents/baseLabel/BaseLabelShade'

const { Sent, Queued, Unavailable } = MultitentativeFillStatus

export default {
  name: 'BookingEducator',
  components: {
    CandidateImage,
    BaseLabel,
  },
  props: {
    educator: {
      type: Object,
      required: true,
    },
  },
  computed: {
    labelColor() {
      const { yellow, purple, grey } = BaseLabelColor

      switch (this.educator.status) {
        case Queued:
          return yellow
        case Sent:
          return purple
        case Unavailable:
          return grey
        default:
          return grey
      }
    },
    labelText() {
      return (
        MultitentativeFillStatusLabels[this.educator.status] ||
        MultitentativeFillStatusLabels.unavailable
      )
    },
    isUnavailable() {
      return this.educator.status === Unavailable
    },
    labelShade() {
      return this.$vuetify?.theme?.isDark
        ? BaseLabelShade.dark
        : BaseLabelShade.light
    },
  },
}
</script>

<template>
  <v-row class="my-1 pl-3">
    <v-col cols="1" class="d-flex align-center">
      <v-lazy>
        <CandidateImage
          :id="educator.id"
          size="sm"
          :full-name="educator.fullName"
        />
      </v-lazy>
    </v-col>
    <v-col cols="4" class="d-flex align-center">
      <p class="mb-0">{{ educator.fullName }}</p>
    </v-col>
    <v-col cols="4"></v-col>
    <v-col cols="3" class="d-flex align-center">
      <BaseLabel
        :class="{ 'opacity-75': isUnavailable }"
        :color="labelColor"
        :text="labelText"
        :shade="labelShade"
      />
    </v-col>
  </v-row>
</template>
